import useBreakpoints from "../hooks/useBreakpoints";

const MOBILE_DRAWER_BREAKPOINTS = new Set(["xs", "sm"]);

export function isMobileDrawerBreakpoint(breakpoint) {
  return MOBILE_DRAWER_BREAKPOINTS.has(breakpoint);
}

export function resolveResponsiveDrawerPosition({ breakpoint, desktopPosition = "end", mobilePosition = "bottom" }) {
  return isMobileDrawerBreakpoint(breakpoint) ? mobilePosition : desktopPosition;
}

export function useResponsiveDrawerPosition({ desktopPosition = "end", mobilePosition = "bottom" } = {}) {
  const breakpoint = useBreakpoints();

  return resolveResponsiveDrawerPosition({
    breakpoint,
    desktopPosition,
    mobilePosition
  });
}
